document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('locale-trigger');
  const modal = document.getElementById('locale-modal');
  const overlay = document.getElementById('locale-modal-overlay');
  const close = document.getElementById('locale-close');
  const localeLinks = document.querySelectorAll('.locale-option');

  const supportedLocales = ['nl', 'fr', 'en', 'de'];
  const origin = window.location.origin;

  // Dynamisch aanpassen van taalwissel-links in modal (met NL als root, altijd absolute URL)
  localeLinks.forEach(link => {
    const newLocale = link.getAttribute('href').replace(/\//g, '').toLowerCase();
    const currentPath = window.location.pathname;
    const query = window.location.search;
    let segments = currentPath.split('/').filter(Boolean);

    let finalUrl = '';
    if (newLocale === 'nl') {
      if (supportedLocales.includes(segments[0])) {
        segments.shift();
      }
      // Altijd een leading slash! (en alleen / op home)
      const newPath = '/' + segments.join('/');
      finalUrl = origin + (newPath === '/' ? '/' : newPath) + query;
    } else {
      if (supportedLocales.includes(segments[0])) {
        segments[0] = newLocale;
      } else {
        segments.unshift(newLocale);
      }
      const newPath = '/' + segments.join('/');
      finalUrl = origin + newPath + query;
    }
    link.setAttribute('href', finalUrl);
  });

  // Modal functionaliteit
  if (trigger && modal && overlay && close) {
    trigger.addEventListener('click', function () {
      modal.classList.remove('hidden');
      overlay.classList.remove('hidden');
    });
    close.addEventListener('click', function () {
      modal.classList.add('hidden');
      overlay.classList.add('hidden');
    });
    overlay.addEventListener('click', function () {
      modal.classList.add('hidden');
      overlay.classList.add('hidden');
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        modal.classList.add('hidden');
        overlay.classList.add('hidden');
      }
    });
  }
});
